import { Link } from 'react-router-dom';
import { ChefHat, Settings2 } from 'lucide-react';

/**
 * Accès compact depuis le plan restaurant — la configuration complète est sur une page dédiée.
 */
export default function RestaurantPrepConfigPanel({ commercantId }) {
  if (!commercantId) return null;

  const prepUrl = `/caisse/restaurant/preparation?commercantId=${encodeURIComponent(commercantId)}`;

  return (
    <div
      className="bg-white rounded-2xl border p-4 space-y-3 lg:col-span-3"
      data-testid="restaurant-prep-config"
    >
      <div className="flex flex-wrap items-center gap-2">
        <ChefHat className="w-5 h-5 text-orange-600" aria-hidden />
        <h2 className="font-semibold text-lg">Préparation & postes (KDS)</h2>
      </div>
      <p className="text-sm text-slate-600">
        Configurez vos postes librement (Cuisine, Bar, Sushi, Grillades…) et affectez le catalogue sur une
        page dédiée, avec recherche, filtres et affectation groupée.
      </p>
      <div className="flex flex-wrap gap-2">
        <Link
          to={prepUrl}
          className="inline-flex items-center gap-2 min-h-[44px] px-4 rounded-xl bg-emerald-600 text-white text-sm font-medium"
          data-testid="restaurant-prep-config-open-page"
        >
          <Settings2 className="w-4 h-4" aria-hidden />
          Ouvrir Préparation & postes
        </Link>
        <Link
          to={`/caisse/kitchen?commercantId=${encodeURIComponent(commercantId)}`}
          className="min-h-[44px] inline-flex items-center px-4 rounded-xl border text-sm text-emerald-800"
          data-testid="restaurant-prep-config-open-kds"
        >
          Écran cuisine (KDS)
        </Link>
      </div>
    </div>
  );
}
